import { render, staticRenderFns } from "./Orderpurchase.vue?vue&type=template&id=061de507&scoped=true&"
import script from "./Orderpurchase.vue?vue&type=script&lang=js&"
export * from "./Orderpurchase.vue?vue&type=script&lang=js&"
import style0 from "./Orderpurchase.vue?vue&type=style&index=0&id=061de507&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061de507",
  null
  
)

export default component.exports